export default __webpack_public_path__ + "static/yahoo-ces-ce4e63c68292a782e7e7d5d02a8b4ee3.png";